"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppBarNotificationMessageDescription = exports.StyledAppBarNotificationMessageText = exports.StyledAppBarNotificationMessage = exports.StyledAppBarNotificationMessageCloseIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../../../helpers");
const Icon_1 = require("../../../../../Icon");
const StackView_1 = require("../../../../../StackView");
const Text_1 = require("../../../../../Text");
exports.StyledAppBarNotificationMessageCloseIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    position: absolute;
    cursor: pointer;
    top: ${helpers_1.SIZE_M};
    right: ${helpers_1.SIZE_M};
`;
exports.StyledAppBarNotificationMessage = (0, styled_components_1.default)(StackView_1.StackView) `
    flex-shrink: 1;
`;
exports.StyledAppBarNotificationMessageText = (0, styled_components_1.default)(Text_1.Text) `
    line-height: 18px;
`;
exports.StyledAppBarNotificationMessageDescription = (0, styled_components_1.default)(exports.StyledAppBarNotificationMessageText) `
    width: max-content;
    white-space: pre-wrap;
    word-break: break-word;
`;
//# sourceMappingURL=NotificationMessage.styles.js.map